import type { RouteRecordRaw } from 'vue-router'

import { registerAlertMessages } from './i18n'

import { ALERTS_PERMISSION_KEY } from '@/shared/config'
import { useLocaleStore } from '@/shared/i18n'

export const ALERTS_ROUTE = { name: 'Alerts' } as const

export const alertRoutes: RouteRecordRaw[] = [
  {
    path: 'tools/alerts',
    name: ALERTS_ROUTE.name,
    component: () => import('./components/AlertsPage.vue'),
    meta: {
      requiresAuth: true,
      permission: ALERTS_PERMISSION_KEY,
      navKey: 'alerts',
      titleKey: 'alerts.page.title',
      contentInset: 'spacious',
    },
    beforeEnter: () => registerAlertMessages(useLocaleStore().locale),
  },
]
